import '../css/ctaSection.css';

const CTASection = () => {
  return (
    <section className="section_CTA mb-5">
      <div className="cta-overlay">
        <div className="cta-content text-center">
          <h2 className="cta-title">
            CHÚNG TÔI VẬN CHUYỂN VÀ HỖ TRỢ CHO{" "}
            <span className="highlight">NHU CẦU KINH DOANH</span> CỦA BẠN.
          </h2>
          <p className="cta-subtitle text-center mx-auto">
            Hãy liên hệ với chúng tôi để được tư vấn và hỗ trợ tốt hơn.
          </p>
          <a href="https://zalo.me/0364758606" className="cta-button">
            LIÊN HỆ
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
